module.exports = __webpack_public_path__ + "static/media/insta.c1482dcf.jpg";